import React from 'react'
import ClientView from './ClientView'

const InventoryView = props => {
  var {
    clients,
    givenOutCodes,
    availableCodes,
    availableMerchandise,
    givenOutMerchandise,
    brandAmbassadors,
    isFetching,
    returnInventoryFromUser,
    assignInventoryToUser,
    missions,
    campaigns,
    selectedTags,
    selectedMerch,
    updateLocalInventoryState,
  } = props

  if (availableCodes == null || givenOutCodes == null || isFetching)
    return <div style={{ padding: 60, height: '100vh' }}>Loading...</div>

  var givenOutCodesByClient = {}
  ;(givenOutCodes || []).forEach(code => {
    givenOutCodesByClient[code.clientId] =
      givenOutCodesByClient[code.clientId] || []
    givenOutCodesByClient[code.clientId].push(code)
  })

  var availableCodesByClient = {}
  ;(availableCodes || []).forEach(code => {
    availableCodesByClient[code.clientId] =
      availableCodesByClient[code.clientId] || []
    availableCodesByClient[code.clientId].push(code)
  })

  var availableMerchandiseByClient = {}
  ;(availableMerchandise || []).forEach(item => {
    availableMerchandiseByClient[item.clientId] =
      availableMerchandiseByClient[item.clientId] || []
    availableMerchandiseByClient[item.clientId].push(item)
  })

  var givenOutMerchandiseByClient = {}
  ;(givenOutMerchandise || []).forEach(item => {
    givenOutMerchandiseByClient[item.clientId] =
      givenOutMerchandiseByClient[item.clientId] || []
    givenOutMerchandiseByClient[item.clientId].push(item)
  })

  // Filter missions by brandAmbassadors
  var brandAmbassadorsHash = {}
  brandAmbassadors.forEach(ba => (brandAmbassadorsHash[ba.id] = ba))
  missions = missions.filter(m => !!brandAmbassadorsHash[m.userId])

  // Filter missions by campaigns
  var campaignsHash = {}
  campaigns.forEach(c => (campaignsHash[c.id] = c))
  missions = missions.filter(m => !!campaignsHash[m.campaignId])

  return clients.map(client => {
    return (
      <ClientView
        updateLocalInventoryState={updateLocalInventoryState}
        key={`client-${client.id}`}
        clientName={client.name}
        clientLogo={shimClientLogo(client)}
        givenOutCodes={givenOutCodesByClient[client.id]}
        availableCodes={availableCodesByClient[client.id]}
        availableMerchandise={availableMerchandiseByClient[client.id]}
        givenOutMerchandise={givenOutMerchandiseByClient[client.id]}
        ambassadors={brandAmbassadors}
        assignInventoryToUser={(inventoryObj, quantity, ambassadorId) => {
          return assignInventoryToUser(
            { ...inventoryObj, clientId: client.id },
            quantity,
            ambassadorId,
          )
        }}
        returnInventoryFromUser={(inventoryObj, quantity, ambassadorId) => {
          return returnInventoryFromUser(
            { ...inventoryObj, clientId: client.id },
            quantity,
            ambassadorId,
          )
        }}
        missions={missions.filter(m => m.clientId == client.id)}
        filterByCodes={selectedTags}
        filterByMerch={selectedMerch}
      />
    )
  })
}

export default InventoryView

/**
 * Returns the client logo, else if one isn't provided uses a third party
 * service to return a url to placeholder image.
 * @param {string} client.logo
 * @param {string} client.name
 * @returns {string} URL of the logo
 */
function shimClientLogo(client) {
  if (client.logo) return client.logo
  return `https://via.placeholder.com/500/3B8000/FFFFFF.png?text=${client.name}`
}



// WEBPACK FOOTER //
// ./src/Containers/Form/City/Pickup/new/InventoryView.js